import { Link } from "react-router";
import { Nett } from "../footer/Nett";
import { handleOpenChat } from "utils/analytics";

export default function Footer() {
  return (
    <>
      <div className="w-full px-5 lg:px-10 py-5 bg-gray-50 border border-gray-100 bg-top">
        <footer className="flex justify-around flex-wrap max-w-screen-xl mx-auto">
          <div className="w-80 p-5">
            <p className="mb-2">Endereço</p>
            <p className="font-light">RROD AL 101 Norte KM 135</p>
            <p className="font-light">Praia de Peroba</p>
            <p className="font-light">Maragogi - Alagoas</p>
          </div>
          <div className="w-80 p-5 flex flex-col">
            <p className="mb-2">Atrações</p>
            <Link className="font-light" to="/piscinas-naturais">
              Piscinas Naturais
            </Link>
            <Link className="font-light" to="/mergulho">
              Mergulho
            </Link>
            <Link className="font-light" to="/fotos-subaquaticas">
              Fotos Subaquáticas
            </Link>
            <Link className="font-light" to="/croa-da-bruna">
              Croa da Bruna
            </Link>
            <Link className="font-light" to="/jetski">
              Jet Ski
            </Link>
          </div>
          <div className="w-80 p-5">
            <p className="mb-2">Fale conosco</p>
            <p className="font-light">reservas@maragogiaomar.com.br</p>
            <p className="font-light">wa.me/5582991445622</p>
            <p className="font-light">+55 (82) 99144-5622</p>
          </div>
          <div className="w-80 p-5">
              <p className="mb-2">Segue a gente</p>
              <div className="flex">
                <a href="https://www.instagram.com/maragogiaomar">
                  <img className="h-8 mr-8" src="/insta.png" alt="MaragogiAoMar" />
                </a>
                <button onClick={handleOpenChat} type="button">
                  <img className="h-8" src="/wpp.png" alt="MaragogiAoMar" />
                </button>
              </div>
          </div>
        </footer>
      </div>
      <Nett />
    </>
  )
}